import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import AccountInfoForm from '../../components/forms/AccountInfoForm/AccountInfoForm';

const AccountInfo = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="account-info">
      <AccountInfoForm userId={uid} />
    </AuthLayout>
  );
};

export default AccountInfo;
